import { GroupInfo, SingleSetting } from "src/components/SettingsEditor";
import { Feature } from "src/states/ApplicationStateFeatures";
import { FRPVisualization } from "./FRPState";



const settingsGroups: GroupInfo = [
  {
    key: "frp",
    da: "FRP",
    en: "FRP"
  }]

const settings: SingleSetting[] = []

export const FRPConst = {
  settingsFixedPriorities: 70,
  settingsGroups: settingsGroups,
  settings: settings,
  defaultColor: "rgba(170, 170, 170, 0.6)",
  processStatusColors: {
    bagTidsplan: "rgba(200, 80, 80, 0.6)",
    manglerTidsplan: "rgba(240, 200, 80, 0.6)",
    folgtTidsplan: "rgba(58, 142, 135, 0.6)",
    ingenStatus: "rgba(238, 238, 238, 0.6)"
  },
  lastChangedColors: {
    oldest: "hsla(0, 0%, 100%, 0.5)",
    newest: "rgba(58, 142, 135, 0.6)"
  },
  progressColors: {
    stripe: "rgba(58, 142, 135, 0.6)", // Same green as folgtTidsplan
    background: "rgba(238, 238, 238, 0.6)" // Default color for background
  },
  visualizations: [
    { id: "status", da: "Status", en: "Status", access: Feature.FRPProjectRead },
    { id: "processStatus", da: "Fremdrift", en: "Process status", access: Feature.FRPProjectRead },
    { id: "progress", da: "% Færdig", en: "% Complete", access: Feature.FRPProjectWrite },
    { id: "lastChanged", da: "Senest ændret", en: "Last changed", access: Feature.FRPProjectWrite },
    { id: "tagsV2", da: "Tags", en: "Tags", access: Feature.FRPProjectWrite },
  ] as FRPVisualization[]
}